// extracted by mini-css-extract-plugin
export var alt = "NodeOffer-module--alt--2cf7f";
export var container = "NodeOffer-module--container--229ea";
export var desktopOnly = "NodeOffer-module--desktopOnly--99bf2";
export var main = "NodeOffer-module--main--c0857";
export var mobileOnly = "NodeOffer-module--mobileOnly--c5842";
export var styleButton = "NodeOffer-module--styleButton--b2c0f";
export var styledLink = "NodeOffer-module--styledLink--0652f";
export var textLeft = "NodeOffer-module--textLeft--86e90";
export var visuallyHidden = "NodeOffer-module--visuallyHidden--67796";